import { useEffect } from 'react';

const SKIP_SELECTORS = [
  '[role="dialog"]',
  '[role="alertdialog"]',
  '[role="combobox"]',
  '[role="listbox"]',
  '[contenteditable="true"]',
  'textarea',
];

const shouldSkipTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) return false;
  return SKIP_SELECTORS.some((selector) => target.closest(selector));
};

export const useEnterEvent = (callBack: () => void) => {
  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent) => {
      if (event.key !== 'Enter') return;
      if (event.isComposing) return;
      if (shouldSkipTarget(event.target)) return;

      event.preventDefault();
      callBack();
    };
    window.addEventListener('keydown', handleKeydown);

    return () => {
      window.removeEventListener('keydown', handleKeydown);
    };
  }, [callBack]);
};
